export default __webpack_public_path__ + "static/media/JobPost.3545958a.png";